export class Emitter<T> {
  private readonly listeners = new Set<(v: T) => void>();

  on(handler: (v: T) => void): () => void {
    this.listeners.add(handler);
    return () => this.listeners.delete(handler);
  }

  emit(value: T): void {
    for (const l of this.listeners) l(value);
  }

  clear(): void {
    this.listeners.clear();
  }
}
